import React from 'react';
import classNames from 'classnames';
import { SwitchToggle } from '../../../../components/SwitchToggle';
import { BaseInputProps } from './BaseInput';

export const BooleanInput: React.FC<BaseInputProps<boolean>> = ({ instance, onChange, disabled = false, className }) => {
  const { config, value } = instance;

  const handleChange = (checked: boolean) => {
    onChange(checked);
  };

  return (
    <div className={classNames('flex items-center', className)}>
      <SwitchToggle switchedOn={typeof value === 'boolean' ? value : false} onChange={handleChange} disabled={disabled || config.disabled} className={classNames(instance.isMixed && 'opacity-50')} />
      {instance.isMixed && <span className="ml-2 text-xs text-gray-400 dark:text-gray-500 italic">Mixed</span>}
    </div>
  );
};
